import DashboardAppScreen from 'domains/Dashboard/screens/App'

export default DashboardAppScreen
